<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Future of Remote Work</h1>
                <h2 class="subheading">For some, working from home is akin to flying business class</h2>
                <span class="meta"> Posted in March 2021 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/forw.png" alt="">
                </figure>

                <p>Has the covid-19 pandemic ushered in a permanent shift in our professional work habits, or will everything return to the former status quo in a year or two?</p>

                <p>This question sits at the root of many of our reflections as we consider where the next areas might lie for VC investment opportunities in enterprise software, particularly in the Japanese market. The “future of work” represents one of our investment themes in Japan, and we like to support software solutions which could enable enterprises to embrace new models, such as we did with <a href="https://markbivens.com/m/archives/the-future-of-work-is-arriving-faster-than-expected-in-japan">enTouch</a> and <a href="http://markbivens.com/m/archives/why-i-invested-in-makeleaps">MakeLeaps</a>.</p>
                
                <p>Our original hypothesis on this question was that yes, the pandemic has catalyzed a permanent mindset shift for working behavior, particularly in Japan.</p>
                
                <p>Traditional incumbent Japanese corporations place a premium on physical office presence. Arrive in the office every morning bright and early, and don’t depart for home until after the boss leaves the office.</p>
                
                <p>The coronavirus pandemic and subsequent lockdown in Japan this past spring forced working from home for over 80% of office workers in downtown Tokyo. The work-from-home model represented a fresh new world for many salaried workers of large companies in Japan. For some, working from home proved highly inconvenient (for a variety of reasons, for instance Japanese homes do not necessarily provide ample space for an isolated home working office area or den). For other people, however, we’ve anecdotally observed that work-from-home is akin to flying business class for the first time. Once you try it, it’s really difficult to return to flying coach class 100% of the time.</p>

                <p>Following this logic, it is hard for us to imagine that all companies in Japan will make a full reversion to the prior status quo of all office presence, all the time. Some employees, perhaps skewed toward the younger ones or those who are more internationally minded, have glimpsed the comfort of business class. We predict that companies who are able to offer some sort of flexible working policy — for instance an ability to work from home one or two days a week — could represent a differentiator in talent recruitment and retention.</p>

                <p>Still, we are cautious in our view and remain willing to revise it as further data comes in. People with far more experience in the Japanese business setting have warned to not underestimate the stamina of corporate inertia in Japan.</p>

                <p>It will be interesting to revisit this prediction post-pandemic.</p>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
